interface PageHeaderProps {
  title: string;
  description: string;
}

/** 화면 제목(Heading 24/B) + 설명(Body 14/M) */
export function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <div className="flex w-full flex-col gap-2">
      <h1 className="text-heading-24 font-bold text-fg-primary">{title}</h1>
      <p className="text-body-14 font-medium text-fg-tertiary">{description}</p>
    </div>
  );
}
